import Vue from 'vue'
import store from '../'

export default {
  namespaced: true,
  state: {
    user: undefined
  },
  getters: {
    state: (state) => state
  },
  actions: {
    setUser ({ commit }, user) {
      commit('setUser', user)
    },
    setUserToken ({ commit }, token) {
      commit('setUserToken', token)
    },
    setUserFromToken ({ commit }, token) {
      const decodedToken = Vue.prototype.$jwt.decode(token)
      const user = {
        login: decodedToken.login,
        fullname: decodedToken.fullname,
        classroom: decodedToken.classroom,
        permissionLevel: decodedToken.permission_level,
        isAdmin: decodedToken.is_admin
      }
      commit('setUser', user)
    },
    diconnectUser ({ commit }) {
      localStorage.removeItem('refreshToken')
      // Reset des états Vuex
      commit('setUser', undefined)
      store.dispatch('detail/setDetailsData', undefined)
      store.dispatch('detail/setSelectedRow', false)
      store.dispatch('detail/setOngoingAlteredRow', false)
      store.dispatch('work/setSelectedWork', undefined)
      store.dispatch('work/setWorksData', undefined)
      store.dispatch('ldap/setClassroomsData', [])
      store.dispatch('ldap/setStudentsData', [])
      store.dispatch('ldap/setStudentsDataMapLogin', [])
      store.dispatch('ldap/setStudentSelectInvisible', true)
      store.dispatch('ldap/setDefaultStudent', undefined)
      store.dispatch('ldap/setDefaultClassroom', undefined)
      store.dispatch('work/resetSeenComment')
    }
  },
  mutations: {
    setUser (state, user) {
      state.user = user
    },
    setUserToken (state, token) {
      state.user.token = token
    }
  }
}
